import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import { toFullName } from '@repo/toolkit/to-full-name'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import { enrollmentActionTypeEnumMapping } from '../../../lib/types/enums/enrollment/enrollment-action-type.enum'
import { EnrollmentAction as EnrollmentActionType } from '../../../lib/types/models/enrollment-actions/enrollment-action'
import { enrollmentActionColorMapping } from './utils/enrollment-action-utils'

type ActionItemType = EnrollmentActionType & { hideBar?: boolean }
type EnrollmentHistoryProps = { data?: EnrollmentActionType[] }

function ActionItem({ type, createdAt, createdBy, hideBar }: ActionItemType) {
  return (
    <div className={'flex flex-row gap-2'}>
      <div className={'flex flex-col gap-1 items-center pt-2'}>
        <div className={'w-1 h-1 bg-grey-lighter rounded-full'} />
        {!hideBar && <div className={'w-[1px] h-full bg-grey-light'} />}
      </div>
      <div className={'flex flex-col gap-1 mb-5'}>
        <Typography variant={'label-semibold'} color={enrollmentActionColorMapping[type]}>
          {enrollmentActionTypeEnumMapping[type]}
        </Typography>

        <Typography variant={'label-medium'} color={tailwindColors.grey.lighter}>
          {DateFormatter.ddMMyyyyHHmm(createdAt)}
        </Typography>

        {createdBy && (
          <div className={'flex flex-wrap gap-1'}>
            <Badge
              text={`${toFullName(createdBy.firstName, createdBy.lastName)} ${createdBy.email}`}
              variant={'white'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export function EnrollmentActions({ data }: EnrollmentHistoryProps) {
  return (
    <div className={'flex flex-col gap-4 p-6 pb-0'}>
      <Typography variant={'body-medium'} color={tailwindColors.primary.DEFAULT}>
        Historique
      </Typography>
      <div className={'flex flex-col gap-2'}>
        {data && data.length > 0
          ? data.map((item, index) => (
              <ActionItem {...item} key={index} hideBar={index === data.length - 1} />
            ))
          : 'Aucune donnée'}
      </div>
    </div>
  )
}
